




















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Tabs from "@/components/Tabs.vue"
import Tab from "@/components/Tab.vue"
import { IRecipient } from "@/entities/notices"

@Component<SelectedRecipientPills>({
    components: { Tab, Tabs }
})
export default class SelectedRecipientPills extends Vue {
    @Prop({ type: Array, required: true }) private recipients !: IRecipient[]
    @Prop({ type: Array, required: true }) private selectedRecipients !: IRecipient[]
    @Prop({ type: Boolean, default: true }) private canRemoveTabs !: boolean
    @Prop({ type: Boolean, default: false }) private canRemoveSingleTabs !: boolean

    private findSelectedRecipientByName(recipientName: String) {
        return this.selectedRecipients.find((recipient: IRecipient) => {
            return recipient.name === recipientName
        })
    }

    private removeRecipient(recipientName: String) {
        const recipient = this.findSelectedRecipientByName(recipientName)
        if (recipient) {
            this.$emit('removeRecipient', recipient)
        }
    }
}

